<template>
  <div class="gift-card-promo-code-input">
    <div class="mt-lg d-flex align-items-center justify-content-end">
      <BaseInput
        v-model.trim="promoCodeInput"
        :disabled="disabled || isApplying"
        class="w-100"
        input-id="promoCode"
        :label="label"/>
      <BaseButton
        :disabled="disabled || isApplying || !promoCodeInput"
        variant="secondary"
        class="ms-md"
        text="Apply"
        tracking-name="Apply Promo"
        :tracking-data="{ input: promoCodeInput }"
        @click="handleApplyClick"/>
    </div>
    <BaseFormErrors
      class="small-text m-0 px-xs"
      :errors="displayErrors"/>
  </div>
</template>

<script setup>
import { watch, computed } from 'vue'
import { useGiftCardPromoCode, CodeInputType } from '@/composables/useGiftCardPromoCode.js'
import BaseInput from '@/components/global/BaseInput.vue'
import BaseFormErrors from '@/components/global/BaseFormErrors.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  accepts: {
    type: String,
    default: CodeInputType.Both,
    validator: value => Object.values(CodeInputType).includes(value)
  },
  errors: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['applied', 'applying', 'error'])

const {
  promoCodeInput,
  internalErrors,
  isApplying,
  applyCode
} = useGiftCardPromoCode({ accepts: () => props.accepts })

const label = computed(() => {
  if (props.accepts === CodeInputType.GiftCard) return 'Gift card'
  if (props.accepts === CodeInputType.PromoCode) return 'Promo code'
  return 'Gift card or promo code'
})

const displayErrors = computed(() => {
  return [...internalErrors.value, ...props.errors]
})

watch(isApplying, (newVal) => {
  emit('applying', newVal)
})

const handleApplyClick = async () => {
  try {
    const result = await applyCode()
    if (result) {
      emit('applied', result)
    }
  } catch (errors) {
    emit('error', errors)
  }
}
</script>

<style lang="scss" scoped>
:deep(.form-control) {
  height: 44px;
}
:deep(.has-float-label .form-control[data-v-65b9ef40]:placeholder-shown:not(:focus) + *) {
  top: 11px;
}
</style>

